import React, { useState, useRef, useEffect } from "react";
import WmModals from "../modals/Wm.Modals";
import API_ENDPOINT from "../wm.api.service";
import axios from "axios";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import Moment from "react-moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import { useQueryClient, useMutation } from "react-query";
import { ExclamationIcon } from "@heroicons/react/outline";
import Spinner from "../Components/spinner/Spinner";
import { getSinglePortfolioDetail, updateProjectData } from "../functions/details";
const Cookie = new Cookies();
function Projectcard({ projectData }) {
  const queryClient = useQueryClient()
  var token = Cookie.get("wmtoken");
  const [editModal, setEditModal] = React.useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({ title: '', description: '', project_url: '', start_date: '', end_date: '', media_privacy: 0, mediaSend: '', media: dummy, currently_working: false });
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(portfolioData.description)
  }, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteFeild = (e, id) => {
    setIsDeleting(true);
    e.preventDefault();
    var fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("field_name", "PROJECT");
    fd.append("field_id", id);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
      data: fd,
    })
      .then(function (response) {
        queryClient.invalidateQueries('projectData')
        setIsDeleting(false);
        setEditModal(false);
        setIsDeleteModalOpen(false);
      })
      .catch(function (err) {
        setIsDeleting(false);
        alert(err.response.data.validation_error.replace(/(<([^>]+)>)/gi, ""))
      });
  }
  const [deleteModal, setIsDeleteModalOpen] = useState(false)
  const imageDelete = (action) => {
    setPortfolioData((prevData) => {
      prevData.media = null
      prevData.mediaSend = null
      return { ...prevData }
    })
  };
  const fetchSingleData = useMutation((documentId) => getSinglePortfolioDetail('PROJECT', documentId), {
    onSuccess: (data) => {
      setPortfolioData({
        identity: data.identity,
        title: data.title,
        project_url: data.project_url,
        description: data.description,
        start_date: data.start_date,
        end_date: data.end_date,
        media_privacy: data.media_privacy === '1' ? true : false,
        currently_working: data.currently_working === '1' ? true : false,
        mediaSend: data.project_media && data.project_media,
        media: data.project_media
      })
      setEditModal(true);
    },
  })
  const updateProject = useMutation((data) => updateProjectData(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('projectData')
      const previousValue = queryClient.getQueriesData('projectData')
      return previousValue
    },
    onError: (previousValue) => {
      queryClient.setQueryData('projectData', previousValue)
    },
    onSuccess: () => {
      queryClient.invalidateQueries('projectData')
      setEditModal(false)
    }
  })
  return (
    <React.Fragment>
      {fetchSingleData.isLoading ? "Fetching Data....." : <div className="shadow educationCard space-y-1 relative p-6 cursor-pointer" onClick={(e) => fetchSingleData.mutate(projectData.identity)}>
        <div className="flex justify-between">
          <span className="text-base md:text-xl inline-block capitalize" style={{"color":"var(--color-5)"}}>{projectData.title}</span>
          <small className="text-xs italic text-gray-600 manpro">
            <Moment format={"YYYY"}>{projectData.start_date}</Moment> - {projectData.currently_working === '1' ? <span className="">Currently Ongoing</span> : <Moment format={"YYYY"}>{projectData.end_date}</Moment>}
          </small>
        </div>
        <div className=""><p className='mb-0 text-sm text-gray-700'>{projectData.description}</p></div>
        <div className="" ><a href={projectData.project_url} className='text-sm underline text-gray-700 italic'>{projectData.project_url}</a></div>
        <div className="flex justify-end">
          {projectData.media_privacy === "1" ? (
            projectData.project_media === null ? ("") : (
              <div className="w-24 h-24 ring-1 ring-gray-300 rounded overflow-hidden">
                <img src={projectData.project_media} alt="media" className=" w-full h-full object-cover" />
              </div>)) : ("")}
        </div>
      </div>}
      {/* EDIT MODAL */}
      <WmModals show={editModal} onHide={() => setEditModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Edit Project Detail</h5>
        <form onSubmit={(e) => { e.preventDefault(); updateProject.mutate(portfolioData) }}>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Project Title <Required /></label>
            <input type="text" placeholder="Project Title" name="institute" className="wm_form_input border-bottom border-gray-300" value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }} />
          </div>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Project Link / URL</label>
            <input type="url" placeholder="Project Link/URL" name="course_title" className="wm_form_input border-bottom border-gray-300" value={portfolioData.project_url} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.project_url = e.target.value; return { ...prevData } }) }} />
            <div>
              <small className='manpro text-gray-600'>Please type in the correct URL for the project http://example.com/</small>
            </div>
          </div>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Description</label>
            <textarea name="description" placeholder="Description" value={portfolioData.description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.description = e.target.value; return { ...prevData } }) }} className="wm_form_input border-bottom border-gray-300" onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150"></textarea>
            <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/150</small>
          </div>
          <Row>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Start Date <Required /></label>
                <DatePicker selected={new Date(portfolioData.start_date)} onChange={(date) => { setPortfolioData((prevData) => { prevData.start_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
              </div>
            </Col>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                {portfolioData.currently_working ? <span className="manpro font-semibold text-lg text-gray-500">Currently Ongoing</span> : <>
                  <label className="wm_form_label">End Date <Required /></label>
                  <DatePicker selected={new Date(portfolioData.end_date)} onChange={(date) => { setPortfolioData((prevData) => { prevData.end_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                </>}
              </div>
            </Col>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Project Ongoing</label>
                <Wmswitch color="success" checked={portfolioData.currently_working} onChange={() => setPortfolioData((prevData) => { prevData.currently_working = !portfolioData.currently_working; return { ...prevData } })} />
              </div>
            </Col>
            <Col md={7}>
              <div className="wm_form_group flex mb-4 items-center">
                <div className="flex flex-col mr-4">
                  <label className="wm_form_label">Media</label>
                  <input type="file" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg" />
                  <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                    {portfolioData.media && portfolioData.media !== "DELETE" ? <img className="object-cover" src={portfolioData.media} alt="education" /> : (
                      <img className="object-cover" src={dummy} alt="education" />)}
                  </div>
                </div>
                <div>
                  <div>
                    <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right">
                      <HelpIcon />
                    </Tooltip>
                  </div>
                  <div>{portfolioData.media && <DeleteForeverIcon className="cursor-pointer" onClick={() => imageDelete("DELETE")} />}</div>
                </div>
              </div>
            </Col>
            <Col md={5}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Show Media</label>
                <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })} />
              </div>
            </Col>
          </Row>
          <div className="wm_form_group">
            <Wmbutton label={updateProject.isLoading ? <CircularProgress className="loader_size_xsm" /> : ("Update")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border" />
            <Wmbutton label="Cancel" onClick={() => setEditModal(false)} className="rounded w-20 mr-2" type="button" color="primary" />
            <Wmbutton label="Delete" onClick={(e) => { setIsDeleteModalOpen(true); setEditModal(false) }} className="rounded w-20" type="button" color="danger" />
          </div>
        </form>
      </WmModals>
      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <div className='px-10 py-4'>
          <div>
            <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Project?</p>
            <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
              <div className='flex space-x-3 p-4'>
                <div>
                  <ExclamationIcon className='w-6 text-red-600' />
                </div>
                <div>
                  <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>Are you sure you want to delete?</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>You can't undo this action.</p>
                </div>
              </div>
            </div>
            <div className='text-center space-x-3 flex justify-center'>
              <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => { setIsDeleteModalOpen(false); setEditModal(true); }}>Cancel</button>
              {isDeleting ? <div className='relative flex items-center justify-center'><Spinner className="" width={20} height={20} /></div> : <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={(e) => { deleteFeild(e, projectData.identity); }}>Delete project</button>}
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}

export default Projectcard;
